export default __webpack_public_path__ + "static/media/About-Us.c47dc95e.jpg";